import Swal from "sweetalert2";
import { grantTrialToUsers } from "../services/userService";

export const openGrantTrialModal = async (
    selectedUserIds,
    selectAllGlobal,
    dispatch,
    navigate,
    setSelectedItems,
    // The list owns its filters (page, search, status and crucially
    // deleted=hide). Refetching from here with empty params fell back to
    // the server defaults and redrew the table with every user including
    // deleted accounts, until the operator refreshed (2026-08-28).
    refreshList
) => {
    const { value: formValues } = await Swal.fire({
        title: "Grant Free Trial",
        html: `
        <div class="d-flex flex-column align-items-center gap-3">
            <input 
                type="number" 
                id="swal-duration" 
                class="form-control form-control-sm w-75" 
                placeholder="Enter Trial Duration (days)" 
                style="font-size:16px; border-radius:7px; padding:6px 12px;"
                min="1"
            />
            <textarea 
                id="swal-reason" 
                class="form-control form-control-sm w-75 mt-2" 
                placeholder="Enter reason for granting trial"
                style="font-size:16px; border-radius:7px; padding:6px 12px;"
            ></textarea>
            <div class="form-check d-flex align-items-center mt-2">
  <input 
    type="checkbox" 
    class="form-check-input mt-0" 
    id="swal-notify" 
    checked 
  />
  <label 
    class="form-check-label ms-2" 
    for="swal-notify"
    style="font-size:15px;"
  >
    Notify users
  </label>
</div>
        </div>
        `,
        focusConfirm: false,
        showCancelButton: true,
        preConfirm: () => {
            const durationInput = document.getElementById("swal-duration");
            const reasonInput = document.getElementById("swal-reason");

            const duration = parseInt(durationInput.value);
            const reason = reasonInput.value.trim();
            const notifyUsers = document.getElementById("swal-notify").checked;

            // Reset previous error borders
            durationInput.style.border = "1px solid #ced4da";
            reasonInput.style.border = "1px solid #ced4da";

            let valid = true;

            if (!duration || duration <= 0) {
                durationInput.style.border = "2px solid red";
                valid = false;
            }

            if (!reason) {
                reasonInput.style.border = "2px solid red";
                valid = false;
            }

            if (!valid) {
                Swal.showValidationMessage("Please fix the errors highlighted above");
                return false;
            }

            return { duration, reason, notifyUsers };
        },
    });

    if (!formValues) return;

    try {
        const userIds = selectAllGlobal ? [] : selectedUserIds;

        await grantTrialToUsers({
            userIds,
            duration: formValues.duration,
            notifyUsers: formValues.notifyUsers,
            reason: formValues.reason,
        });

        Swal.fire({
            icon: "success",
            title: "Trial Granted",
            text: `Successfully granted a ${formValues.duration}-day trial to ${selectAllGlobal ? "all users" : selectedUserIds.length + " users"}`
        });

        if (typeof setSelectedItems === "function") {
    setSelectedItems(new Set());
}

        if (typeof refreshList === "function") {
            refreshList();
        }
    } catch (err) {
        console.error(err);
        Swal.fire("Error", err?.response?.data?.message || err.message || "Failed to grant trial", "error");
    }
};
